// AdminHomePage — visão geral do painel admin com cards de atalho
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { admin } from '../../lib/api.js';

export default function AdminHomePage() {
  const [kpis, setKpis] = useState(null);
  const [ops, setOps]   = useState([]);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    Promise.all([
      admin.kpisBackoffice(30).catch(() => null),
      admin.listarOperadores().catch(() => ({ data: [] })),
    ]).then(([k, o]) => {
      setKpis(k);
      setOps(o?.data || []);
    }).catch(e => setErro(e.uiMessage || 'Erro ao carregar'));
  }, []);

  const totalAtivos = ops.filter(o => o.ativo).length;
  const totalAdmins = ops.filter(o => o.ativo && o.papel === 'admin').length;

  return (
    <div className="stack">
      <h1 style={{ marginBottom: 4 }}>Painel Administrativo</h1>
      <p style={{ color: '#6b7280', marginTop: 0, marginBottom: 24 }}>
        Gestão de usuários, indicadores operacionais e marca do sistema.
      </p>

      {erro && <div className="card error">{erro}</div>}

      <div className="admin-cards">
        <Link to="/admin/usuarios" className="admin-card">
          <div className="admin-card-ico">👥</div>
          <div className="admin-card-title">Usuários</div>
          <div className="admin-card-value">{totalAtivos}</div>
          <div className="admin-card-meta">ativos · {totalAdmins} admin{totalAdmins!==1?'s':''}</div>
        </Link>

        <Link to="/admin/kpis/backoffice" className="admin-card">
          <div className="admin-card-ico">🤖</div>
          <div className="admin-card-title">Propostas IA (30d)</div>
          <div className="admin-card-value">{kpis?.globais?.total ?? '—'}</div>
          <div className="admin-card-meta">
            {kpis?.globais?.taxa_resposta_pct != null
              ? `${kpis.globais.taxa_resposta_pct}% respondidas`
              : 'sem dados'}
          </div>
        </Link>

        <Link to="/admin/branding" className="admin-card">
          <div className="admin-card-ico">🎨</div>
          <div className="admin-card-title">Marca</div>
          <div className="admin-card-value" style={{ fontSize: 18 }}>Logo + cores</div>
          <div className="admin-card-meta">trocar identidade visual</div>
        </Link>
      </div>

      {kpis?.globais && kpis.globais.expiradas / Math.max(1, kpis.globais.total) > 0.5 && (
        <div className="alert-block">
          <strong>⚠ Alerta operacional:</strong> {kpis.globais.expiradas} de {kpis.globais.total} propostas IA
          ({Math.round(kpis.globais.expiradas / kpis.globais.total * 100)}%) expiraram nos últimos 30 dias.
          {' '}<Link to="/admin/kpis/backoffice">Ver detalhes →</Link>
        </div>
      )}
    </div>
  );
}
